module.exports = __webpack_public_path__ + "static/theofilis-8d5614ea9059e8aa68a3b5c4a6723a94.png";